// assets/haxe-video.js
(function () {
  function makeIframeSrc(id) {
    var p = new URLSearchParams({
      autoplay: 1, mute: 1, rel: 0, modestbranding: 1, playsinline: 1
    });
    return "https://www.youtube.com/embed/" + id + "?" + p.toString();
  }
  function toIframe(wrapper) {
    var ytId = wrapper && wrapper.getAttribute("data-yt");
    if (!ytId) return;
    var iframe = document.createElement("iframe");
    iframe.src = makeIframeSrc(ytId);
    iframe.title = "YouTube video player";
    iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
    iframe.allowFullscreen = true;
    iframe.loading = "lazy";
    iframe.referrerPolicy = "strict-origin-when-cross-origin";
    iframe.style.width = "100%";
    iframe.style.height = "100%";
    iframe.style.border = "0";
    wrapper.innerHTML = "";
    wrapper.appendChild(iframe);
  }
  function activate(e) {
    var isClick = e.type === "click";
    var isKey = e.type === "keydown" && (e.key === "Enter" || e.key === " " || e.key === "Spacebar");
    if (!isClick && !isKey) return;
    var wrap = (e.currentTarget.closest && e.currentTarget.closest(".video-ratio")) || e.currentTarget;
    toIframe(wrap);
    if (isKey) e.preventDefault();
  }
  function init() {
    document.querySelectorAll(".video-ratio[data-yt]").forEach(function (wrap) {
      var btn = wrap.querySelector(".video-placeholder") || wrap;
      btn.setAttribute("role", "button");
      btn.setAttribute("tabindex", "0");
      if (!btn.getAttribute("aria-label")) btn.setAttribute("aria-label", "Odtwórz wideo");
      btn.addEventListener("click", activate);
      btn.addEventListener("keydown", activate);
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
